import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { mountMfe } from '@schwab/mfe-registry/mount'
import { defineCustomElements } from '@schwab/web-components/dist/loader';
import { AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise'
import { ModuleRegistry, ClientSideRowModelModule, provideGlobalGridOptions, ValidationModule } from 'ag-grid-community';
import { singleSpaPropsSubject } from './single-spa/single-spa-props';

function ensureAgGridStyleInjectionState(): void {
  const win = window as any;
  const state = win.agStyleInjectionState;

  if (!state || typeof state !== 'object') {
    win.agStyleInjectionState = { map: new WeakMap(), grids: new Map() };
    return;
  }

  // Defensive fix for mixed AG Grid versions sharing window.agStyleInjectionState.
  if (!(state.map instanceof WeakMap)) {
    state.map = new WeakMap();
  }

  if (!(state.grids instanceof Map)) {
    state.grids = new Map();
  }
}

try {
  defineCustomElements(window);
} catch (e) {
  console.log('Everest custom elements already defined', e);
}

if (environment.production) {
  enableProdMode();
}

const agGridLicenseKey: string = (window as any)?.thirdParty?.agGridKey;

mountMfe('money-movement-ui-root', (singleSpaProps: any) => {

  singleSpaPropsSubject.next(singleSpaProps);

  ensureAgGridStyleInjectionState();

  // ag-grid set-up
  if(agGridLicenseKey){
    LicenseManager.setLicenseKey(atob(agGridLicenseKey));
  }
  provideGlobalGridOptions({ theme: "legacy"});
  ModuleRegistry.registerModules([ClientSideRowModelModule]);
  ModuleRegistry.registerModules([AllEnterpriseModule, ValidationModule]);

  var platform = platformBrowserDynamic();
  if ((window as any).ngZone) {
    return platform.bootstrapModule(AppModule, { ngZone: (window as any).ngZone });
  } else {
    return platform.bootstrapModule(AppModule);
  }
});